import { Record, List } from "immutable";

import { CarrierService } from "./carrier-service";

const defaults = {
    id: undefined,
    services: undefined,
};

interface ICarrierService {
    id: string;
    carrierId: string;
    carrierCode: string;
    serviceCode: string;
    name: string;
    domestic: boolean;
    international: boolean;
    isMultiPackageSupported: boolean;
}

export class CarrierServicesList extends Record(defaults) {
    declare id: string;
    declare services: [ICarrierService];

    constructor(args) {
        super({
            ...args,
            id: args.carrierId,
            services: List(args.services && args.services.map((val) => new CarrierService(val))),
        });
    }
}
